import React from "react";
import Tooltip from "../components/tooltip/Tooltip";
import models from "./models";
import i18next from "i18next";

const renderUtils = {

    renderMachineType: (machine, t) => {
        const machineTypes = {
            "BLISTERING": t ? t("devices.blistering") : "Blistrownica",
            "CARTON": t ? t("devices.carton") : "Kartoniarka",
            "CAPPER": t ? t("devices.capper") : "Zakręcarka",
            "WEIGHT_SELECTOR": t ? t("devices.weight_selector") : "Selektor wagowy",
            "MULTI_CHANNEL_SELECTOR": t ? t("devices.multi_channel_selector") : "Selektor wielotorowy",
            "ANTARES": t ? t("devices.antares") : "Antares",
            "VIGNETTES": t ? t("devices.vignettes") : "Winietkarka",
            "DATAMATRIX": t ? t("devices.datamatrix") : "Datamatrix",
            "COMMON_CARTON": t ? t("devices.common_carton") : "Pakowarka zbiorcza",
            "BLOWING_MACHINE": t ? t("devices.blowing_machine") : "Przedmuchiwarka",
            "COUNTER_MACHINE": t ? t("devices.counter_machine") : "Liczarka",
            "LABELLING_MACHINE": t ? t("devices.labelling_machine") : "Etykieciarka",
            "PACKAGER": t ? t("devices.packager") : "Pakieciarka",
            "SACHET_MACHINE": t ? t("devices.sachet_machine") : "Saszetkarka",
            "BOTTLING_MACHINE": t ? t("devices.bottling_machine") : "Rozlewnica",
            "TAMPER": t ? t("devices.tamper") : "Tamper",
            "PALLETIZER": t ? t("devices.palletizer") : "Paletyzer",
            "MACHINE_1": t ? t("devices.machine_1") : "Maszyna 1",
            "MACHINE_2": t ? t("devices.machine_2") : "Maszyna 2",
            "MACHINE_3": t ? t("devices.machine_3") : "Maszyna 3",
        };
        return machineTypes[machine.machineType] ? machineTypes[machine.machineType] : machine.machineType
    },

    renderMachine: (machine) => {
        return [machine.model, machine.serialNumber]
            .filter(item => item && item.trim() !== "")  // Filter out empty or blank strings
            .join(" ");  // Join the remaining strings with a
    },

    renderMachineModel: (machineModel) => {
        return [machineModel.model]
            .filter(item => item && item.trim() !== "")  // Filter out empty or blank strings
            .join(" ");  // Join the remaining strings with a
    },

    renderOperatingParameterTemplate: (template) => {
        return [template.name, template.value]
            .filter(item => item && item.trim() !== "")  // Filter out empty or blank strings
            .join(" ");  // Join the remaining strings with a
    },

    renderEnumName: (enumValue, enumType, t) => {
        const renderConfig = {
            "enums/packingSystem": {
                "ALU_ALU": "ALU/ALU",
                "PVC_ALU": "PVC/ALU",
            },
            "enums/formatStatus": {},
            "enums/storageInventoryDetailsStatus": {
                "PROCESSED": t ? t("enums.processed") : "Tak",
                "NOT_PROCESSED": t ? t("enums.not_processed") : "Nie",
                "NOT_APPLICABLE": t ? t("enums.not_applicable") : "Nie dotyczy",
            },
            "enums/partType": {
                "BASIC": t ? t("enums.basic") : "Podstawowe",
                "DEDICATED": t ? t("enums.dedicated") : "Dedykowane",
            },
            "enums/capsuleOrTablet": {
                "CAPSULE": t ? t("devices.capsule") : "Kapsułka",
                "TABLET": t ? t("devices.tablet") : "Tabletka",
            },
            "enums/machineType": {
                "BLISTERING": t ? t("devices.blistering") : "Blistrownica",
                "CARTON": t ? t("devices.carton") : "Kartoniarka",
                "CAPPER": t ? t("devices.capper") : "Zakręcarka",
                "WEIGHT_SELECTOR": t ? t("devices.weight_selector") : "Selektor wagowy",
                "MULTI_CHANNEL_SELECTOR": t ? t("devices.multi_channel_selector") : "Selektor wielotorowy",
                "ANTARES": t ? t("devices.antares") : "Antares",
                "VIGNETTES": t ? t("devices.vignettes") : "Winietkarka",
                "DATAMATRIX": t ? t("devices.datamatrix") : "Datamatrix",
                "COMMON_CARTON": t ? t("devices.common_carton") : "Pakowarka zbiorcza",
                "BLOWING_MACHINE": t ? t("devices.blowing_machine") : "Przedmuchiwarka",
                "COUNTER_MACHINE": t ? t("devices.counter_machine") : "Liczarka",
                "LABELLING_MACHINE": t ? t("devices.labelling_machine") : "Etykieciarka",
                "PACKAGER": t ? t("devices.packager") : "Pakieciarka",
                "SACHET_MACHINE": t ? t("devices.sachet_machine") : "Saszetkarka",
                "BOTTLING_MACHINE": t ? t("devices.bottling_machine") : "Rozlewnica",
                "TAMPER": t ? t("devices.tamper") : "Tamper",
                "PALLETIZER": t ? t("devices.palletizer") : "Paletyzer",
                "MACHINE_1": t ? t("devices.machine_1") : "Maszyna 1",
                "MACHINE_2": t ? t("devices.machine_2") : "Maszyna 2",
                "MACHINE_3": t ? t("devices.machine_3") : "Maszyna 3",
            },
            "globalConfigKey": {
                "CLEANING_WARNING_DURATION": t ? t("parameters.cleaning_warning_duration") : "Ile dni ważne czyszczenie"
            },
            "auditActionType": {
                "EDITION": t ? t("parameters.edition") : "Edycja",
                "CREATION": t ? t("parameters.creation") : "Utworzenie",
                "CONFIGURATION_START": t ? t("parameters.configuration_start") : "Rozpoczęcie konfiguracji",
                "CONFIGURATION_END": t ? t("parameters.configuration_end") : "Zakończonie konfiguracji",
                "MOVE_TO_PRODUCTION": t ? t("parameters.move_to_production") : "Przekazanie do produkcji",
                "SAT": t ? t("parameters.sat_execution") : "Wykonanie SAT",
                "SAT_ACCEPTATION": t ? t("parameters.sat_acceptation") : "Zatwierdzenie SAT",
                "CLEANING": t ? t("menu.cleaning") : (models.cleaning?.title || "Czyszczenie"),
                "STORAGE": t ? t("menu.storage") : (models.storage?.title || "Przechowywanie"),
                "SERVICE_START": t ? t("menu.service_start") : (models.serviceStart?.title || "Do serwisu"),
                "SERVICE_END": t ? t("menu.service_end") : (models.serviceEnd?.title || "Z serwisu"),
                "DIMENSIONING_START": t ? t("menu.dimensioning_start") : (models.dimensioningStart?.title || "Wydano do zmywiarowania"),
                "DIMENSIONING_END": t ? t("menu.dimensioning_end") : (models.dimensioningEnd?.title || "Po zmywiarowaniu"),
                "REVIEW": t ? t("menu.inventory") : (models.review?.title || "Przegląd"),
                "WITHDRAWAL": t ? t("menu.exchange") : (models["part-replacement"]?.title || "Wymiana"),
                "PART_WITHDRAWAL": t ? t("menu.withdrawal") : (models["part-withdrawal"]?.title || "Wycofanie"),
                "PART_INSTALLATION_START": t ? t("parameters.part_installation_start") : "Urządzono na linii",
                "PART_PRODUCTION_START": t ? t("parameters.part_production_start") : "Start produkcji z użyciem części",
                "PART_PRODUCTION_END": t ? t("parameters.part_production_end") : "Koniec produkcji z użyciem części",
                "PART_INSTALLATION_END": t ? t("parameters.part_installation_end") : "Koniec urządzenia na linii",
                "PRODUCTION_START": t ? t("parameters.production_start") : "Start produkcji",
                "PRODUCTION_END": t ? t("parameters.production_end") : "Koniec produkcji",
                "DELETE": t ? t("parameters.delete") : "Usunięcie",
                "INVENTORY": t ? t("parameters.inventory") : "Przegląd",
                "CHANGE_STATUS": t ? t("parameters.change_status") : "Zmiana statusu",
                "INVENTORY_START": t ? t("parameters.inventory_start") : "Początek inwentaryzacji",
                "INVENTORY_END": t ? t("parameters.inventory_end") : "Koniec inwentaryzacji",
                "IN": t ? t("parameters.in") : "Wprowadzenie",
                "OUT": t ? t("parameters.out") : "Wydanie",
            },
            "enums/objectType": {
                "LINE": t ? t("object_types.line") : "Linia",
                "MACHINE": t ? t("object_types.machine") : "Maszyna",
                "MACHINE_MODEL": t ? t("object_types.machine_model") : "Model maszyny",
                "FORMAT_PART": t ? t("object_types.format_part") : "Część formatowa",
                "FORMAT": t ? t("object_types.format") : "Format",
                "PART": t ? t("object_types.part") : "Część",
                "PRODUCTION": t ? t("object_types.production") : "Produkcja",
                "STORAGE_PLACE": t ? t("object_types.storage_place") : "Szafa formatowa",
                "ALARM": t ? t("object_types.alarm") : "Alarm",
                "FONT": t ? t("object_types.font") : "Czcionki",
                "FAST_ACTING_PART_CATEGORY": t ? t("object_types.fast_acting_part_category") : "Części szybkozużywające się - Kategorie",
                "FAST_ACTING_PART": t ? t("object_types.fast_acting_part") : "Częśc szybkozużywająca się",
                "OPERATING_PARAMETER_TEMPLATE": t ? t("object_types.operating_parameter_template") : "Parametry pracy",
                "OPERATING_PARAMETER_TEMPLATE_GROUP": t ? t("object_types.operating_parameter_template_group") : "Grupy parametrów pracy",
            }
        };

        if (renderConfig[enumType]) {
            const result = renderConfig[enumType][enumValue];
            return result || enumValue;
        } else {
            return enumValue;
        }
    },

    renderStatus: (status, className, disableTopMargin, t) => {
        const statusMapping = {
            CONFIGURATION: {label: t ? t("status.configuration") : "W trakcie konfiguracji", className: "badge badge-secondary"},
            WAITING_FOR_MOVING: {label: t ? t("status.waiting_for_moving") : "W trakcie przekazania", className: "badge badge-warning"},
            SAT: {label: t ? t("status.sat") : "W trakcie SAT", className: "badge badge-warning"},
            SAT_ACCEPTATION: {label: t ? t("status.sat_acceptation") : "W trakcie akceptacji", className: "badge badge-warning"},
            STORAGE: {label: t ? t("status.storage") : "W magazynie", className: "badge badge-primary"},
            PRODUCTION: {label: t ? t("status.production") : "Produkcja", className: "badge badge-success"},
            WITHDRAWN: {label: t ? t("status.withdrawn") : "Zutylizowany", className: "badge badge-dark"}
        };

        const defaultClassName = "font-max " + (disableTopMargin ? "" : "mt-2")
        const statusInfo = statusMapping[status];
        return statusInfo
            ? <span className={`${statusInfo.className} ${defaultClassName} ${className}`}>{statusInfo.label}</span>
            : (t ? t("common.unknown_status") : "Niewiadomy status");
    },

    renderPartStatus: (status, className, disableTopMargin, t) => {
        const partStatusMapping = {
            STORAGE: {label: t ? t("status.storage") : "W magazynie", className: "badge badge-secondary",},
            SERVICE: {label: t ? t("status.service") : "W serwisie", className: "badge badge-warning"},
            INSTALLED: {label: t ? t("status.installed") : "W użyciu", className: "badge badge-primary"},
            PRODUCTION: {label: t ? t("status.production") : "Produkcja", className: "badge badge-danger"},
            DIMENSIONING: {label: t ? t("status.dimensioning") : "W zwymiarowaniu", className: "badge badge-info"},
            WITHDRAWN: {label: t ? t("status.withdrawn") : "Zutylizowany", className: "badge badge-dark"},
            DELETED: {label: t ? t("status.deleted") : "Usunięty", className: "badge badge-danger"}
        };

        const defaultClassName = "font-max " + (disableTopMargin ? "" : "mt-2")
        const statusInfo = partStatusMapping[status];
        return statusInfo
            ? <span className={`${statusInfo.className} ${defaultClassName} ${className}`}>{statusInfo.label}</span>
            : (t ? t("common.unknown_status") : "Niewiadomy status");
    },

    renderAlarmStatus: (status, count, t) => {
        const alarmStatus = {
            CREATED: {label: t ? t("status.created") : "Utworzono", className: "badge badge-warning", variant: "warning"},
            IN_PROGRESS: {label: t ? t("status.in_progress") : "W trakcie", className: "badge badge-primary", variant: "primary"},
            DONE: {label: t ? t("status.done") : "Zakończono", className: "badge badge-success", variant: "success"},
        };

        console.log("count: ", count)
        const defaultClassName = "font-max mr-2"

        const statusInfo = alarmStatus[status];
        return statusInfo
            ? <span
                className={`${statusInfo.className} ${defaultClassName}`}>{`${statusInfo.label}${count ? ` (${count})` : ""}`}</span>
            : (t ? t("common.unknown_status") : "Niewiadomy status");
    },

    renderAlarmDate: (status, date, t) => {
        const alarmStatus = {
            CREATED: {label: t ? t("status.created") : "Utworzono", className: "badge badge-warning", variant: "warning"},
            IN_PROGRESS: {label: t ? t("status.in_progress") : "W trakcie", className: "badge badge-primary", variant: "primary"},
            DONE: {label: t ? t("status.done") : "Zakończono", className: "badge badge-success", variant: "success"},
        };

        const defaultClassName = "font-max mr-2"
        const statusInfo = alarmStatus[status];
        return <Tooltip tooltip={t ? t("common.creation_date") : "Data utworzenia"}>
            <span className={`${statusInfo.className} ${defaultClassName} `}>{date}</span>
        </Tooltip>;
    },

    renderAlarmStatusButton: (status, onClick, t) => {
        const alarmStatusButton = {
            CREATED: {
                label: t ? t("status.start") : "Rozpocznij",
                icon: "fa-play",
                className: "badge badge-warning",
                variant: "warning",
                toStatus: "IN_PROGRESS"
            },
            IN_PROGRESS: {
                label: t ? t("status.finish") : "Zakończ",
                icon: "fa-check",
                className: "badge badge-primary",
                variant: "primary",
                toStatus: "DONE"
            },
        };

        const defaultClassName = "font-max"
        const statusInfo = alarmStatusButton[status];
        return statusInfo
            ? <Tooltip tooltip={statusInfo.label}>
                <span onClick={() => onClick(statusInfo.toStatus)}
                      className={`ml-1 cursor-pointer ${statusInfo.className} ${defaultClassName}`}><i
                    className={"fas " + statusInfo.icon}></i></span>
            </Tooltip>
            : "";
    }
};

export const alarmStatus = {
    CREATED: {label: i18next.t("status.created"), className: "badge badge-warning", variant: "warning"},
    IN_PROGRESS: {label: i18next.t("status.in_progress"), className: "badge badge-primary", variant: "primary"},
    DONE: {label: i18next.t("status.done"), className: "badge badge-success", variant: "success"},
};

// Alternative approach: function that accepts t parameter
export const getAlarmStatus = (t) => ({
    CREATED: {label: t ? t("status.created") : i18next.t("status.created"), className: "badge badge-warning", variant: "warning"},
    IN_PROGRESS: {label: t ? t("status.in_progress") : i18next.t("status.in_progress"), className: "badge badge-primary", variant: "primary"},
    DONE: {label: t ? t("status.done") : i18next.t("status.done"), className: "badge badge-success", variant: "success"},
});

export default renderUtils;
